import { PolicyModels } from './policy.models';
import { KeyValuePair } from './technical/key-value-pair';

export namespace PaymentModels {
  export interface PaymentOrderResume {
    mobile?: string;
    email?: string;
    creationDate: Date;
    amount: number;
    expiracyDate: Date;
    paymentDate?: Date;
  }

  export interface PaymentOrderDetails {
    id: number;
    amount: number;
    receipts: PaymentOrderReceipt[];
    expiracyDate: Date;
  }

  export interface PaymentOrderReceipt {
    number: number;
    type: PolicyModels.ReceiptTypeEnum;
    amount: number;
    rejectFees?: number;
  }

  export interface SendPaymentOrderRequest {
    receipts: number[];
    policyId: number;
    mobile: string;
    email: string;
  }

  export interface PaymentTransaction {
    id: number;
    amount: number;
    effectiveDate?: Date;
    state: PaymentTransactionStatusEnum;
    isAccounted: boolean;
    stateReason?: PaymentModels.PaymentTransactionReasonEnum;
    payzenId: string;
  }

  export enum FromPayzenStatus {
    Success = 1,
    Error = 2,
    Refused = 3,
    Cancelled = 4,
  }

  export interface PaymentTransactionInfos {
    paymentStatus: PaymentTransactionStatusEnum;
    paymentStatusReason: PaymentTransactionReasonEnum;
  }

  export enum PaymentTransactionStatusEnum {
    WaitingPayzen = 1,
    Abandoned = 2,
    Authorised = 3,
    Captured = 4,
    Refused = 5,
    Canceled = 6,
  }

  export enum PaymentModeEnum {
    Prelevement = 1,
    Cheque = 2,
    CB = 3,
    Virement = 4,
  }

  export interface PaymentRequest {
    successUrl: string;
    refusedUrl: string;
    cancelUrl: string;
    errorUrl: string;
  }

  export interface PayzenPayload {
    pzProps: KeyValuePair<string, string>[];
    pzUrl: string;
  }

  export enum PaymentTransactionReasonEnum {
    TransactionApprouveeOuTraiteeAvecSucces = 0,
    ContacterEmetteurDeCarte = 2,
    AccepteurInvalide = 3,
    ConserverLaCarte = 4,
    NePasHonorer = 5,
    ConserverLaCarteConditionsSpeciales = 7,
    ApprouverApresIdentification = 8,
    TransactionInvalide = 12,
    MontantInvalide = 13,
    NumeroDePorteurInvalide = 14,
    EmetteurDeCarteInconnu = 15,
    AnnulationAcheteur = 17,
    RepeterLaTransactionUlterieurement = 19,
    ReponseErronee = 20,
    MiseAJourDeFichierNonSupportee = 24,
    ImpossibleDeLocaliserEnregistrementDansLeFichier = 25,
    EnregistrementDupliqueAncienEnregistrementRemplace = 26,
    ErreurEnEditSurChampDeListeaJourFichier = 27,
    MiseAJourImpossible = 29,
    ErreurDeFormat = 30,
    IdentifiantOrganismeAcquereurInconnu = 31,
    DateDeValiditeDeLaCarteDepassee1 = 33,
    SuspicionDeFraude1 = 34,
    DateDeValiditeDeLaCarteDepassee2 = 38,
    CartePerdue = 41,
    CarteVolee = 43,
    ProvisionInsuffisanteOuCreditDepasse = 51,
    DateDeValiditeDeLaCarteDepassee3 = 54,
    CodeConfidentielErrone = 55,
    CarteAbsenteDuFichier = 56,
    TransactionNonPermisePorteurFrauduleux = 57,
    TransactionNonPermisePorteur = 58,
    SuspicionDeFraude2 = 59,
    AccepteurDeCarteDoitContacterAcquereur = 60,
    MontantDeRetraitHorsLimite = 61,
    ReglesDeSecuriteNonRespectees = 63,
    ReponseNonParvenueOuReçueTropTard = 68,
    NombreEssaisCodeConfidentielDepasse = 75,
    PorteurDejaEnOppositionAncienEnregistrementConserve = 76,
    ArretMomentaneDuSysteme = 90,
    emetteurDeCartesInaccessible = 91,
    AccesInterditAuFichier = 28,
    TransactionDupliquee = 94,
    MauvaisFonctionnementDuSysteme = 96,
    echeanceDeLaTemporisationDeSurveillanceGlobale = 97,
    ServeurIndisponibleRoutageReseauDemandeNouveau = 98,
    IncidentDomaineInitiateur = 99,
  }

  export enum PaymentOrderType {
    Manual = 1,
    CronD4 = 2,
    CronD15 = 3,
    CronD30 = 4,
  }
}
